import React, { JSX, useEffect, useState } from 'react';
import ToolTip from '../ToolTip/ToolTip';
import RichText from '../richtext';
import Styles from './ChooseGiftV2.module.scss';

const ChooseGift = ({ content, selectedGiftItem, parentPoType }: any): JSX.Element => {
  const [activeItem, setActiveItem] = useState(0);
  const [gift, setGift] = useState<any>(content?.listOfGifts?.[0]);

  const handleChooseGift = (item: any, index: any) => {
    setGift(item);
    setActiveItem(index);
    selectedGiftItem({
      tuaProdId: item?.tuaProdId,
      giftGroupId: content?.giftGroupId,
      parentPoType: parentPoType
    });
  };
  useEffect(() => {
    //loop through list of gifts and select the one with default selection
    let defaultSelection = false;
    content?.listOfGifts?.map((item: any, index: number) => {
      if (item.is_default) {
        setGift(item);
        setActiveItem(index);
        defaultSelection = true;
        selectedGiftItem({
          tuaProdId: item?.tuaProdId,
          giftGroupId: content?.giftGroupId,
          parentPoType: parentPoType
        });
      }
    });
    if (!defaultSelection) {
      selectedGiftItem({
        tuaProdId: content?.listOfGifts?.[0].tuaProdId,
        giftGroupId: content?.giftGroupId,
        parentPoType: parentPoType
      });
    }
  }, []);

  return (
    <div>
      <div className={Styles.giftcontainer}>
        <div className={Styles.giftlist}>
          <span className={Styles.gifticon}>
            <img src={content?.giftIcon?.filename} width={24} height={24} alt='giftIcon'/>
          </span>
          <span className={Styles.gifttitle}>{content?.title}</span>
          <div className={Styles.gifttooltip}>
            <ToolTip content={content?.tooltipText} />
          </div>
        </div>
        <div className={Styles.giftsection}>
          {content?.listOfGifts?.map((item: any, index: number) => {
            return (
              <div
                key={index}
                onClick={() => handleChooseGift(item, index)}
                className={`${Styles.giftimagecontainer} ${index === activeItem && Styles.giftimg}`}
              >
                <img src={item.image?.filename} width={64} height={64} alt='image'/>
              </div>
            );
          })}
        </div>
        <div className={Styles.giftdescription}>
          <span className={Styles.description}>{gift?.title}</span> <br />
          <span className={Styles.giftprice}>
            {gift?.description && <RichText content={gift?.description} />}
          </span>
        </div>
      </div>
    </div>
  );
};
export default ChooseGift;
